/* eslint-disable react/no-danger */
import { Grid2, Show } from "components";
import { isEmpty } from "lodash";
import { useAppSelector } from "store/store";

const ViewRationaleTab = () => {
  const { selectedBasket: data } = useAppSelector(
    (state) => state?.equityBasket,
  );

  return (
    <Grid2 container>
      <Show.When isTrue={!isEmpty(data?.rationale)} showNodata>
        <Grid2 size={10}>
          <div
            className="ck"
            style={{
              color: "#222",
              lineHeight: "26px",
              fontSize: 14,
              textAlign: "justify",
            }}
            dangerouslySetInnerHTML={{
              __html: data?.rationale || "",
            }}
          />
        </Grid2>
      </Show.When>
    </Grid2>
  );
};

export default ViewRationaleTab;
